<template>
  <div>
    <Header />
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div
      class="container mx-auto max-w-[1200px] w-full py-3 flex flex-col gap-10 px-4 md:px-6 lg:gap-16"
    >
      <div class="w-full h-full flex flex-col gap-2">
        <div class="flex items-center justify-between">
          <h1 class="text-xl font-semibold text-gray-800">
            Staff List
            <span class="ml-2 text-sm font-normal text-gray-500">
              ({{ studentcount || 0 }})
            </span>

            <span
              v-if="userSelectList.length > 0"
              class="ml-3 pl-3 border-l border-gray-200 text-sm font-medium text-indigo-600"
            >
              Selected: {{ userSelectList.length }}
            </span>
          </h1>
        </div>
        <div
          class="flex flex-col flex-wrap gap-4 md:flex-row md:items-center md:justify-end"
        >
          <div>
            <select
              v-model="selectFieldFilter"
              @change="handleFieldFilterChange"
              class="w-full rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="" disabled>Select Status</option>
              <option value="True">Active</option>
              <option value="False">Inactive</option>
            </select>
          </div>
          <!-- Start Date -->
          <div class="flex flex-col relative">
            <label
              class="absolute -top-2.5 left-3 bg-gray-50 px-1 text-xs font-medium text-gray-600"
            >
              Start Date
            </label>
            <input
              type="date"
              v-model="startDate"
              @change="onStartDateChange"
              class="px-1 py-1.5 border border-gray-300 rounded-xl shadow-sm text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white w-full"
            />
          </div>

          <!-- End Date -->
          <div class="flex flex-col relative">
            <label
              class="absolute -top-2.5 left-3 bg-gray-50 px-1 text-xs font-medium text-gray-600"
            >
              End Date
            </label>
            <input
              type="date"
              v-model="endDate"
              @change="onEndDateChange"
              class="px-1 py-1.5 border border-gray-300 rounded-xl shadow-sm text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white w-full"
            />
          </div>

          <div class="flex justify-end">
            <div class="relative w-full md:max-w-80">
              <div
                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              <input
                type="text"
                v-model="searching"
                @input="fetchstudent(1)"
                placeholder="Search..."
                class="w-full rounded-xl border border-gray-200 bg-white pl-10 pr-10 py-2 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
              />
              <button
                v-if="searching"
                @click="clearSearch"
                class="absolute inset-y-0 right-0 pr-3 flex items-center"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4 text-gray-400 hover:text-gray-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>
          <div>
            <button
              @click="clearFilters"
              class="rounded-xl bg-slate-200 px-4 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-300 transition"
            >
              Clear
            </button>
          </div>
          <div v-if="this.userSelectList != 0">
            <button
              class="bg-blues text-white px-5 py-2 rounded-2xl font-semibold text-sm flex items-center justify-center hover:bg-hover transition-all duration-200"
              @click="userdeownload"
              :disabled="isDownload"
            >
              <span v-if="!isDownload">Download</span>
              <span v-else class="flex items-center gap-2">
                <svg
                  class="animate-spin h-4 w-4 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    class="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                  ></circle>
                  <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8z"
                  ></path>
                </svg>
                Download...
              </span>
            </button>
          </div>
        </div>
        <div
          class="w-full bg-[#edf8ff] flex justify-center gap-5 items-center px-2 py-2 mb-4 lg:px-8 rounded-md"
          v-if="response_message"
        >
          <h2 class="text-textblues text-center">
            {{ response_message }}
          </h2>

          <router-link
            :to="{ name: 'DownloadHistory' }"
            class="text-blue-600 text-xs underline font-bold"
          >
            Download History
          </router-link>
        </div>
        <div>
          <div
            v-if="loading"
            class="flex items-center justify-center"
            style="height: calc(100vh - 350px) !important"
          >
            <img src="@/assets/newd/loading.gif" alt="" />
          </div>
          <div v-else class="w-full">
            <div v-if="this.studentlist.length > 0">
              <div
                class="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-x-auto"
              >
                <table class="min-w-full text-sm table-auto">
                  <thead class="bg-gray-100 whitespace-nowrap">
                    <tr>
                      <th
                        class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
                      >
                        <input
                          type="checkbox"
                          v-model="selectAll"
                          @change="toggleSelectAll"
                          class="w-4 h-4 rounded text-blue-600 border-gray-400"
                        />
                      </th>
                      <th
                        class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
                      >
                        S.No
                      </th>
                      <th
                        class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
                      >
                        Staff Info
                      </th>
 <th
                        class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
                      >
                        Permission
                      </th>
                      <th
                        class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
                      >
                        Created
                      </th>
                      <th
                        class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
                      >
                        IP Address
                      </th>
                      <th
                        class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
                      >
                        Last Login
                      </th>
                      <th
                        class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
                      >
                        Last Logout
                      </th>
                      <!-- <th
                        class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
                      >
                        Login Duration
                      </th> -->

                      <th
                        class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
                      >
                        Password
                      </th>
                      <th
                        class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
                      >
                        Status
                      </th>
                      <!-- <th
                        class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
                      >
                        <div class="flex flex-col items-center gap-1">
                          <p class="">Notification</p>
                          <span class="text-xs text-blue-600"
                            >(Read/Total)</span
                          >
                        </div>
                      </th>
                      <th
                        class="py-3 px-4 border-b border-r font-semibold text-textblues text-left"
                      >
                        <div class="flex flex-col items-center gap-1">
                          <p class="">Email</p>
                          <span class="text-xs text-blue-600"
                            >(Read/Total)</span
                          >
                        </div>
                      </th> -->
                    </tr>
                  </thead>

                  <tbody class="divide-y divide-gray-100">
                    <tr
                      v-for="(el, index) in studentlist"
                      :key="index"
                      class="hover:bg-gray-50 transition whitespace-nowrap"
                    >
                      <td class="py-3 px-4 border-r text-left">
                        <input
                          type="checkbox"
                          :value="el?.user?.id"
                          v-model="userSelectList"
                          class="w-4 h-4 rounded text-blue-600 border-gray-400"
                        />
                      </td>
                      <td class="py-3 px-4 border-r text-left text-xs">
                        {{ (currentPage - 1) * pageSize + index + 1 }}
                      </td>
                      <td class="py-2 px-4 border-r text-left text-gray-700">
                        <div class="">
                          <!-- Name -->
                          <div class="font-semibold text-blue-600 text-xs">
                            <span
                            
                              class="uppercase"
                            >
                              {{ el?.user?.display_name || "NA" }}
                            </span>
                          </div>
                          <!-- Email -->
                          <div class="text-xs text-gray-600 flex gap-1">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              height="12px"
                              viewBox="0 -960 960 960"
                              width="12px"
                              fill="#4B5563"
                              class="mt-1"
                            >
                              <path
                                d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200ZM160-640v-80 480-400Z"
                              />
                            </svg>
                            {{ el?.user?.email || "NA" }}
                          </div>

                          <!-- Meta info -->
                          <!-- <div
                            class="text-xs text-gray-500 flex flex-wrap gap-3"
                          >
                            <span
                              ><b>PRN:</b> {{ el?.prn_number || "NA" }}</span
                            >
                            <span
                              ><b>Semester:</b>
                              {{ el?.semester?.semester || "NA" }}</span
                            >
                          </div> -->
                        </div>
                      </td>
 <td
                        class="py-3 px-4 border-r text-left whitespace-nowrap text-gray-700 text-xs"
                      >
                        {{ el?.user_permission || "NA" }}
                      </td>
                      <td
                        class="py-3 px-4 border-r text-left whitespace-nowrap text-gray-700 text-xs"
                      >
                        {{
                          formatDate(el?.created) || "NA"
                        }}
                      </td>
                      <td
                        class="py-3 px-4 border-r text-left whitespace-nowrap text-gray-700 text-xs"
                      >
                        {{ el?.user?.ip_address || "NA" }}
                      </td>
                      <td
                        class="py-3 px-4 border-r text-left whitespace-nowrap text-gray-700 text-xs"
                      >
                        {{ formatDate(el?.log_duration?.loged_in) || "NA" }}
                      </td>
                      <td
                        class="py-3 px-4 border-r text-left whitespace-nowrap text-gray-700 text-xs"
                      >
                        {{ formatDate(el?.log_duration?.loged_out) || "NA" }}
                      </td>
                      <!-- <td
                        class="py-3 px-4 border-r text-left whitespace-nowrap text-gray-700 text-xs"
                      >
                        {{ formatDuration(el?.log_duration?.duration) }}
                      </td> -->

                      <!-- <td
                        class="py-3 px-4 border-r text-left whitespace-nowrap text-gray-700"
                      >
                        {{ el?.pnr_number || "NA" }}
                      </td> -->

                      <td
                        class="py-3 px-4 border-r text-left whitespace-nowrap text-gray-700"
                      >
                        <div class="flex justify-center">
                          <button
                            @click.stop="fetchOpen(el?.user?.email)"
                            class="flex items-center gap-2 px-3 py-1.5 bg-blue-50 text-blue-700 border border-blue-200 rounded-md hover:bg-blue-100 transition-all text-xs font-semibold shadow-sm"
                            title="Change Password"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="16"
                              height="16"
                              class="telegram-icon"
                            >
                              <path
                                d="M2.74 10.6l3.94 1.27 9.54-4.56c.45-.27.86-.12.52.19l-7.68 6.92-.28 4.23c.43 0 .62-.19.84-.41l1.91-1.84 3.98 2.94c.73.39 1.25.18 1.43-.69l2.62-12.34c.27-1.08-.4-1.57-1.1-1.25L2.93 9.35c-1.05.42-1.04 1.01-.19 1.25z"
                              />
                            </svg>
                          </button>
                        </div>
                      </td>
                      <td
                        class="py-3 px-4 border-r text-left whitespace-nowrap text-gray-700 text-xs"
                      >
                        <label
                          class="relative inline-block w-12 h-7 sm:w-10 sm:h-5"
                        >
                          <input
                            type="checkbox"
                            class="peer opacity-0 w-0 h-0"
                            :checked="el?.user?.is_active"
                            @change="handleToggle(el)"
                          />
                          <!-- Track -->
                          <span
                            :class="[
                              'absolute cursor-pointer top-0 left-0 right-0 bottom-0 rounded-full transition duration-300',
                              el.user.is_active ? 'bg-[#22c55e]' : 'bg-red-500',
                            ]"
                          ></span>

                          <!-- Knob -->
                          <span
                            :class="[
                              'absolute border border-white rounded-full transition duration-300',
                              'bottom-[5px] left-[4px] h-5 w-5 sm:h-[15px] sm:w-[15px] sm:bottom-[2.5px] sm:left-[2px]',
                              el?.user?.is_active
                                ? 'translate-x-[22px] sm:translate-x-[18px] bg-white'
                                : 'translate-x-0 bg-white',
                            ]"
                          ></span>
                        </label>
                      </td>
                      <!-- <td
                        class="py-3 px-4 border-r border-gray-100 text-center whitespace-nowrap"
                      >
                        <div class="flex items-center justify-center gap-3">
                          <router-link
                            :to="{
                              name: 'StudentNotificationList',
                              params: {
                                id: el?.user?.id,
                                email: encodeURIComponent(el?.user?.email),
                              },
                            }"
                            class="group flex items-center gap-2 px-3 py-1.5 bg-gray-50 hover:bg-blue-50 rounded-lg transition-all duration-200 cursor-pointer"
                          >
                            <div class="flex items-center gap-1">
                              <span class="font-bold text-blue-600 text-xs">{{
                                el?.read_notification_count || 0
                              }}</span>
                              <span class="text-gray-500 text-xs">/</span>
                              <span
                                class="font-semibold text-gray-700 text-xs"
                                >{{ el?.notification_count || 0 }}</span
                              >
                            </div>
                            <svg
                              class="w-3.5 h-3.5 text-blue-400 group-hover:text-blue-600 transition-all duration-200 group-hover:translate-x-0.5"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M9 5l7 7-7 7"
                              />
                            </svg>
                          </router-link>
                        </div>
                      </td>

                      <td
                        class="py-3 px-4 border-r border-gray-100 text-center whitespace-nowrap"
                      >
                        <div class="flex items-center justify-center gap-3">
                          <router-link
                            :to="{
                              name: 'StudentEmailList',
                              params: {
                                id: el?.user?.id,
                                email: encodeURIComponent(el?.user?.email),
                              },
                            }"
                            class="group flex items-center gap-2 px-3 py-1.5 bg-gray-50 hover:bg-blue-50 rounded-lg transition-all duration-200 cursor-pointer"
                          >
                            <div class="flex items-center gap-1">
                              <span class="font-bold text-blue-600 text-xs">{{
                                el?.email_history_read_count || 0
                              }}</span>
                              <span class="text-gray-500 text-xs">/</span>
                              <span
                                class="font-semibold text-gray-700 text-xs"
                                >{{ el?.email_history_count || 0 }}</span
                              >
                            </div>
                            <svg
                              class="w-3.5 h-3.5 text-blue-400 group-hover:text-blue-600 transition-all duration-200 group-hover:translate-x-0.5"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M9 5l7 7-7 7"
                              />
                            </svg>
                          </router-link>
                        </div>
                      </td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                v-if="studentcount >= 11"
                class="flex flex-col sm:flex-row justify-center gap-3 mt-4 relative"
              >
                <!-- PAGE SIZE -->
                <div
                  class="md:absolute md:left-3 md:top-4 gap-2 text-sm text-gray-600 flex justify-center items-center md:flex-none md:justify-normal"
                >
                  <span class="flex md:hidden">Rows per page:</span>
                  <select
                    v-model="pageSize"
                    @change="onPageSizeChange"
                    class="border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option :value="10">10</option>
                    <option :value="20">20</option>
                    <option :value="50">50</option>
                    <option :value="100">100</option>
                  </select>
                </div>

                <!-- PAGINATION -->
                <div class="flex justify-center">
                  <Pagination
                    :totalPages="totalPages"
                    ref="paginationRef"
                    @page-changed="fetchstudent"
                  />
                </div>
              </div>
            </div>
            <div
              v-else
              class="flex flex-col items-center justify-center min-h-[800px]"
            >
              No Data Found
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="isOpen"
      class="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 px-4"
    >
      <div
        class="bg-white rounded-2xl shadow-2xl w-full max-w-md max-h-[90vh] overflow-hidden flex flex-col relative"
      >
        <div
          class="flex items-center justify-between p-5 border-b border-gray-200"
        >
          <h2 class="text-xl font-semibold text-gray-800">Change Password</h2>
          <button
            @click="isOpen = false"
            class="text-gray-500 hover:text-red-500 text-2xl"
          >
            &times;
          </button>
        </div>
        <div
          class="p-6 overflow-y-auto text-gray-700 text-sm leading-relaxed whitespace-pre-wrap"
        >
          <form @submit.prevent="changePassword" class="flex flex-col gap-4">
            <div>
              <label class="leading-7 text-sm text-gray-600">Email</label>

              <input
                name="Email"
                v-model="currentEmail"
                readonly
                class="w-full bg-gray-100 rounded border border-gray-300 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out cursor-not-allowed"
                placeholder="Email"
              />
            </div>

            <div>
              <label class="block font-medium text-gray-700 mb-1">
                Password <span class="text-red-400">*</span>
              </label>

              <!-- Radio Options -->
              <div class="flex gap-4 mb-2">
                <label class="flex items-center space-x-2 cursor-pointer">
                  <input
                    type="radio"
                    value="custom"
                    v-model="passwordOption"
                    class="form-radio text-blue-500"
                  />
                  <span>Custom</span>
                </label>

                <label class="flex items-center space-x-2 cursor-pointer">
                  <input
                    type="radio"
                    value="auto"
                    v-model="passwordOption"
                    class="form-radio text-blue-500"
                    @click="autoGeneratePassword"
                  />
                  <span>Auto Generate</span>
                </label>
              </div>

              <!-- Custom Password Input -->
              <div v-if="passwordOption === 'custom'">
                <label class="leading-7 text-sm text-gray-600"
                  >Custom Password</label
                >

                <div class="relative">
                  <input
                    @change="emptyspaceremove"
                    :type="showPassword ? 'text' : 'password'"
                    id="password"
                    v-model="Password"
                    class="w-full bg-white rounded border border-gray-300 focus:ring-2 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                    placeholder="Enter Password"
                    required
                  />

                  <img
                    v-if="!showPassword"
                    src="@/assets/eyeslash.svg"
                    @click="togglePassword"
                    alt="show password"
                    class="absolute top-3 right-3 cursor-pointer"
                  />

                  <img
                    v-else
                    src="@/assets/eye.svg"
                    @click="togglePassword"
                    alt="hide password"
                    class="absolute top-3 right-3 cursor-pointer"
                  />
                </div>
              </div>

              <!-- Auto Generated Password -->
              <div v-if="passwordOption === 'auto'">
                <label class="leading-7 text-sm text-gray-600"
                  >Generated Password</label
                >

                <input
                  id="password"
                  type="text"
                  :value="Password"
                  readonly
                  class="w-full p-2 border border-gray-300 rounded bg-gray-100 cursor-not-allowed"
                />
              </div>
            </div>

            <div class="flex justify-end mt-4">
              <button
                v-if="!loadings"
                type="submit"
                class="bg-blue-500 text-white py-2 px-6 text-sm rounded-lg hover:bg-hover transition relative"
              >
                Submit
              </button>

              <div v-if="loadings" class="flex gap-5 items-center">
                <button
                  type="submit"
                  class="bg-black text-white py-2 px-6 text-sm rounded-lg"
                  style="background-color: #0f172a !important"
                >
                  Loading...
                </button>

                <div class="spinner"></div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!--Active Popup -->
    <div
      v-if="showPopup"
      class="fixed bg-black bg-opacity-50 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
    >
      <div
        class="lg:w-[40%] 2xl:w-[30%] bg-white rounded-xl p-10 overflow-y-auto max-h-[600px]"
      >
        <div class="w-full flex flex-col relative rounded-2xl">
          <div class="w-full flex flex-col gap-8">
            <h1
              v-if="this.checkbox_status == false"
              class="font-bold text-sm text-red-400 text-center"
            >
              Do You Want To Deactivate This User
              <span class="text-sm text-textblues">{{ dep_email }}</span
              >?
            </h1>
            <h1 v-else class="font-bold text-sm text-green-400 text-center">
              Do You Want To Activate This User
              <span class="text-sm text-textblues">{{ dep_email }}</span
              >?
            </h1>
            <div class="flex items-center justify-center gap-5">
              <button
                @click="cancelToggle"
                class="bg-blues hover:bg-hover text-white rounded-xl text-sm font-semibold px-6 py-2"
              >
                No
              </button>
              <button
                @click="confirmToggle"
                class="bg-blues hover:bg-hover text-white rounded-xl text-sm font-semibold px-6 py-2"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Pagination from "@/components/Pagination.vue";
import Header from "@/components/Admin/Header.vue";
import FlashMessage from "@/components/FlashMessage.vue";
export default {
  data() {
    return {
      messages: {
        text: "",
        type: "null",
      },
      studentlist: [],
      loading: true,
      loadings: false,
      currentPage: 1,
      totalPages: 1,
      selectfilter: "",
      selectFieldFilter: "",
      selectProgramfilter: "",
      searching: "",
      pageSize: 10,
      studentcount: "",
      departments: [],
      isOpen: false,
      currentEmail: "",
      Password: "",
      showPassword: false,
      passwordOption: "custom",
      selectAll: false,
      studentAllList: [],
      userSelectList: [],
      response_message: "",
      isDownload: false,
      showPopup: false,
      pendingItem: null,
      dep_email: "",
      checkbox_status: false,
      programs: [],
      startDate: "",
      endDate: "",
    };
  },
  components: {
    Header,
    FlashMessage,
    Pagination,
  },
  watch: {
    passwordOption(newVal) {
      if (newVal === "auto") {
        this.autoGeneratePassword();
      } else {
        this.Password = "";
      }
    },
    userSelectList(newVal) {
      if (!this.studentAllList.length) return;

      const validIds = this.studentAllList.map((x) => x.user.id);

      const filtered = newVal.filter((id) => validIds.includes(id));

      if (filtered.length !== newVal.length) {
        this.userSelectList = filtered;
        return;
      }

      this.selectAll =
        filtered.length > 0 && filtered.length === this.studentAllList.length;
    },
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },
  mounted() {
    // this.fetchAllstudent();
  },
  created() {
    this.fetchAllstudent();
    this.fetchstudent(1);
    this.fetchdepartments();
    this.getPrograms();
  },
  methods: {
    clearSearch() {
      this.searching = "";
      this.fetchstudent(1);
    },
    getPrograms() {
      axios
        .get(
          `${process.env.VUE_APP_API}/program-list/?Key=${this.userInfo.token_key}`,
        )
        .then((res) => {
          this.programs = res.data.data;
        });
    },
    handleFilterChange() {
      this.selectAll = false;
      this.userSelectList = [];

      this.fetchAllstudent(); // full list
      this.fetchstudent(1); // paginated list
    },
    handleProgramFilterChange() {
      this.selectAll = false;
      this.userSelectList = [];

      this.fetchAllstudent(); // full list
      this.fetchstudent(1); // paginated list
    },
    handleFieldFilterChange() {
      this.selectAll = false;
      this.userSelectList = [];

      this.fetchAllstudent(); // full list
      this.fetchstudent(1); // paginated list
    },
    handleToggle(item) {
      if (item) {
        this.pendingItem = item;
        this.dep_email = item.user.email;
        this.showPopup = true;
        if (item.user.is_active == true) {
          this.checkbox_status = false;
        } else {
          this.checkbox_status = true;
        }
      }
    },
    cancelToggle() {
      this.pendingItem = null;
      this.showPopup = false;
    },
    confirmToggle() {
      if (this.pendingItem) {
        this.updateStatus(this.pendingItem, false);
        this.pendingItem = null;
        this.showPopup = false;
      }
    },

    async updateStatus(item) {
      let acceptsVal = {};
      if (item.user.is_active == true) {
        acceptsVal = {
          is_active: false,
          demo_user: true,
        };
      } else {
        acceptsVal = {
          is_active: true,
          demo_user: false,
        };
      }

      axios
        .put(
          `${process.env.VUE_APP_API}/profile/is-active/${item.user.id}/?Key=${this.userInfo.token_key}`,
          acceptsVal,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            console.log("successful");
            this.fetchstudent(1);
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            console.log("not successful");
          }
        })
        .catch((error) => {
          this.messages = {
            text: error.response.data.error,
            type: "error",
          };
        });

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
      }, 3000);
    },
    isActive(index) {
      return index === this.b_value.length - 1;
    },
    async userdeownload() {
      if (this.isDownload) return;
      this.isDownload = true;

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API}/staff/csv/export/?Key=${this.userInfo.token_key}`,
          {
            user_ids: this.userSelectList,
            department_id: this.selectfilter,
            is_active: this.selectFieldFilter,
            program_id: this.selectProgramfilter,
            start_date: this.startDate,
            end_date: this.endDate,
          },
        );

        if (response.data.status === 200) {
          this.response_message =
            "Your file is ready to download go to download history page";

          setTimeout(() => {
            this.response_message = "";
            this.isDownload = false;
            this.userSelectList = [];
            this.startDate = "";
            this.endDate = "";
          }, 5000);
        } else {
          this.messages = {
            text: "Event Failed",
            type: "error",
          };
          console.log("not successful");
        }
      } catch (error) {
        console.error("Delete error:", error);
        this.messages = {
          text: "Something went wrong. Please try again.",
          type: "error",
        };
      } finally {
        setTimeout(async () => {
          this.messages = { text: "", type: "" };
        }, 2500);
      }
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.userSelectList = this.studentAllList.map((x) => x.user.id);
      } else {
        this.userSelectList = [];
      }
    },
    formatDuration(duration) {
      if (!duration) return "NA";
      const [hh, mm, ss] = duration.split(":");
      const seconds = parseInt(ss);
      return `${seconds} sec`;
    },
    emptyspaceremove() {
      this.Password = this.Password.replace(/\s+/g, "");
    },

    togglePassword() {
      this.showPassword = !this.showPassword;
    },

    autoGeneratePassword() {
      const chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

      let generated = "";

      for (let i = 0; i < 10; i++) {
        generated += chars.charAt(Math.floor(Math.random() * chars.length));
      }

      this.Password = generated;
    },
    async onStartDateChange() {
      this.currentPage = 1;
      this.fetchAllstudent();
      await this.fetchstudent(1);
    },

    async onEndDateChange() {
      this.currentPage = 1;
      this.fetchAllstudent();
      await this.fetchstudent(1);
    },
    fetchOpen(data) {
      this.currentEmail = data;
      this.isOpen = true;
    },
    clearFilters() {
      this.selectfilter = "";
      this.selectFieldFilter = "";
      this.selectProgramfilter = "";
      this.searching = "";
      this.userSelectList = [];
      this.selectAll = false;
      this.startDate = "";
      this.endDate = "";

      this.fetchAllstudent();
      this.fetchstudent(this.current_page);
    },
    async fetchdepartments() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/department-list/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response) {
            this.departments = response.data.data;
          } else {
            console.log("got error");
          }
        });
    },
    formatDate(date) {
      if (!date) return "";

      const d = new Date(date);

      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");

      let hours = d.getHours();
      const minutes = String(d.getMinutes()).padStart(2, "0");
      const seconds = String(d.getSeconds()).padStart(2, "0");

      const ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12 || 12;
      hours = String(hours).padStart(2, "0");

      return `${yyyy}-${mm}-${dd}, ${hours}:${minutes}:${seconds} ${ampm}`;
    },
    onPageSizeChange() {
      this.currentPage = 1;
      if (this.$refs.paginationRef) {
        this.$refs.paginationRef.currentPage = 1;
      }
      this.fetchstudent(1);
    },
    async fetchAllstudent() {
      let params = {
        Key: this.userInfo.token_key,
        // user__demo_user: false,
      };

      if (this.searching) {
        params.search = this.searching;
      }

      if (this.selectfilter) {
        params.department__id = this.selectfilter;
      }

      if (this.selectProgramfilter) {
        params.program__id = this.selectProgramfilter;
      }

      if (this.selectFieldFilter === "True") {
        params.user__is_active = true;
        params.user__demo_user = false;
      } else if (this.selectFieldFilter === "False") {
        params.user__is_active = false;
        params.user__demo_user = true;
      } else {
        params.user__demo_user = false;
      }
      // if (this.selectFieldFilter) {
      //   params.user__is_active = this.selectFieldFilter;
      // }

      // Date filters
      if (this.startDate) {
        params.start_date = this.startDate;
      }
      if (this.endDate) {
        params.end_date = this.endDate;
      }

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/staff-details-select/list/`,
          { params },
        );

        if (response.data.status === 200) {
          this.studentAllList = response.data.data || [];
          this.studentcount = response.data.count || 0;

          // Reset checkbox selection
          this.userSelectList = [];
          this.selectAll = false;
        }
      } catch (error) {
        console.error("Error fetching all students:", error);
      }
    },
    applyCustomDate() {
      this.currentPage = 1;
      this.fetchstudent(1);
    },
    clearDates() {
      this.startDate = "";
      this.endDate = "";
      this.currentPage = 1;
      this.fetchstudent(1);
    },
    async fetchstudent(page) {
      this.currentPage = page;

      let params = {
        Key: this.userInfo.token_key,
        page: page,
        page_size: this.pageSize,
        // user__demo_user: false,
      };

      if (this.selectfilter) {
        params.department__id = this.selectfilter;
      }
      if (this.selectFieldFilter === "True") {
        params.user__is_active = true;
        params.user__demo_user = false;
      } else if (this.selectFieldFilter === "False") {
        params.user__is_active = false;
        params.user__demo_user = true;
      } else {
        params.user__demo_user = false;
      }
      // if (this.selectFieldFilter) {
      //   params.user__is_active = this.selectFieldFilter;
      // }
      if (this.selectProgramfilter) {
        params.program__id = this.selectProgramfilter;
      }
      if (this.searching) {
        params.search = this.searching;
      }
      if (this.startDate) {
        params.start_date = this.startDate;
      }
      if (this.endDate) {
        params.end_date = this.endDate;
      }

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/staff-list/`,
          { params },
        );

        if (response.data.data.status === 200) {
          this.studentlist = response.data.data.data;
          this.studentcount = response.data.data.count;
          this.totalPages = response.data.total_page;
          this.current_page = response.data.current_page;
          this.loading = false;
        }
      } catch (error) {
        console.error(error);
      }
    },

    changePassword() {
      this.loadings = true;
      const payload = {
        email: this.currentEmail,
        password: this.Password,
      };
      axios
        .post(
          `${process.env.VUE_APP_API}/user/password/update/?Key=${this.userInfo.token_key}`,
          payload,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.loadings = false;
              this.isOpen = false;
              this.Password = "";
              this.passwordOption = "custom";
              this.fetchstudent(this.currentPage);
            }, 2500);
          } else {
            let errorMessage = "Something went wrong";

            if (typeof response.data.message === "object") {
              if (response.data.message.password) {
                errorMessage = response.data.message.password[0];
              } else {
                errorMessage = Object.values(response.data.message)
                  .flat()
                  .join(", ");
              }
            } else {
              errorMessage = response.data.message;
            }

            this.messages = {
              text: errorMessage,
              type: "error",
            };
            // this.messages = {
            //   text: response.data.message,
            //   type: "error",
            // };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.Password = "";
              this.passwordOption = "custom";
              this.loadings = false;
            }, 2000);
          }
        })
        .catch((error) => {
          console.log("error...", error);
          this.loadings = false;
        });
    },
  },
};
</script>

<style scoped>
.spinner {
  --d: 8.6px;
  width: 1.5px;
  height: 1.5px;
  border-radius: 50%;
  color: #a6acb7;
  box-shadow: calc(1 * var(--d)) calc(0 * var(--d)) 0 0,
    calc(0.707 * var(--d)) calc(0.707 * var(--d)) 0 0.5px,
    calc(0 * var(--d)) calc(1 * var(--d)) 0 1px,
    calc(-0.707 * var(--d)) calc(0.707 * var(--d)) 0 1.4px,
    calc(-1 * var(--d)) calc(0 * var(--d)) 0 1.9px,
    calc(-0.707 * var(--d)) calc(-0.707 * var(--d)) 0 2.4px,
    calc(0 * var(--d)) calc(-1 * var(--d)) 0 2.9px;
  animation: spinner-a90wxe 1s infinite steps(8);
}

@keyframes spinner-a90wxe {
  100% {
    transform: rotate(1turn);
  }
}
</style>
